import styled from "styled-components";

export const IGCIndicatorBallWrapperDefaultBox = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    border: ${({theme}) => `2px solid ${theme.colors.backgroundContrast}`};
    border-radius: 50%;
    height: 3.5rem;
    width: 3.5rem;

    @media ${({theme}) => theme.mediaQuery.lAndAbove} {
        border-color: ${({theme}) => theme.colors.boxBorderContrast};
    }
`;
